/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mMenu.vue?vue&type=template&id=2188a522&scoped=true"
import script from "./mMenu.vue?vue&type=script&lang=js"
export * from "./mMenu.vue?vue&type=script&lang=js"
import style0 from "./mMenu.vue?vue&type=style&index=0&id=2188a522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188a522",
  null
  
)

export default component.exports